import { render, staticRenderFns } from "./HKLFragment.vue?vue&type=template&id=24ea4a04&"
import script from "./HKLFragment.vue?vue&type=script&lang=js&"
export * from "./HKLFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ea4a04')) {
      api.createRecord('24ea4a04', component.options)
    } else {
      api.reload('24ea4a04', component.options)
    }
    module.hot.accept("./HKLFragment.vue?vue&type=template&id=24ea4a04&", function () {
      api.rerender('24ea4a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Layout/HKLFragment.vue"
export default component.exports